module.exports = __webpack_public_path__ + "img/BTM-alt.819de557.svg";